// src/components/TrainingTeaser.js
import React from 'react';
import { Link } from 'react-router-dom';
import { GraduationCap, ArrowRight, Clock, Award } from 'lucide-react';
import '../styles/TrainingTeaser.css';

const TrainingTeaser = () => {
  return (
    <section className="training-teaser-section">
      <div className="training-teaser-container">
        <div className="training-teaser-icon-wrapper">
          <GraduationCap className="training-teaser-icon" />
        </div>
        <div className="training-teaser-content">
          <span className="training-teaser-badge">Training & Internship</span>
          <h2 className="training-teaser-title">
            6-Week & 6-Month Training and Internship Programs for Students
          </h2>
          <p className="training-teaser-text">
            For BCA, B.Tech, MCA, M.Tech and B.Sc IT students &mdash; hands-on programs in web development,
            mobile development, architecture &amp; system design, SEO, cloud infrastructure, AI tools,
            prompt engineering, and Claude (Anthropic) AI.
          </p>
          <div className="training-teaser-meta">
            <span className="training-teaser-meta-item">
              <Clock className="training-teaser-meta-icon" />
              6 Weeks or 6 Months
            </span>
            <span className="training-teaser-meta-item">
              <Award className="training-teaser-meta-icon" />
              Certificate on completion
            </span>
          </div>
          <Link to="/training" className="training-teaser-cta">
            Explore Training Programs
            <ArrowRight className="training-teaser-cta-icon" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default TrainingTeaser;
